import React from 'react'

const CheckboxDocuments = (
    {
        isTheDocumentIncludedInThePresentation,
        doc,
        selectDocumentsToAddToPresentation,
        idPresentation
    }
) => {
    
    return (
        <>
            {
                isTheDocumentIncludedInThePresentation(doc) ?
                idPresentation ?
                        <input type="checkbox"
                            defaultChecked={isTheDocumentIncludedInThePresentation(doc)}
                            value={doc}
                            onClick={(event) => selectDocumentsToAddToPresentation(event, doc, isTheDocumentIncludedInThePresentation(doc))}
                        />
                    :
                        <input type="checkbox" checked={true} readOnly />
                :
                    <input
                        type="checkbox"
                        value={doc}
                        onChange={(event) => selectDocumentsToAddToPresentation(event, doc, isTheDocumentIncludedInThePresentation(doc))}
                    />
            }                                              
        </>
    )
}

export default CheckboxDocuments